var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "white",
    stroke: "#FC686F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8382 7.31211C17.1999 6.91544 17.8074 6.89401 18.195 7.26423C18.5826 7.63445 18.6036 8.25614 18.2418 8.65281L11.5218 16.0212C11.1708 16.4061 10.5858 16.4394 10.1953 16.0968L6.83526 13.1494C6.43271 12.7963 6.38609 12.1761 6.73113 11.7641C7.07618 11.3522 7.68222 11.3045 8.08477 11.6576L10.7461 13.9921L16.8382 7.31211Z",
    fill: "#FC686F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleActive);
export default __webpack_public_path__ + "static/media/circle-active.7d390c3fb46fd374dbf4b898333e4890.svg";
export { ForwardRef as ReactComponent };